import { ChevronDown } from 'lucide-react'

/**
 * Верхний хват нижнего шита: пилюля + стрелка-вниз. Тап сворачивает шит.
 *
 * Зачем: свайп-вниз в Telegram WebView сворачивает ВСЁ мини-приложение, а не
 * закрывает конкретный шит. Поэтому каждому нижнему шиту нужна явная кнопка
 * сворачивания — её и даёт этот компонент (ставится вместо grip-пилюли сверху).
 */
export function SheetGrip({ onClose, pillColor = '#D1D5DB' }: { onClose: () => void; pillColor?: string }) {
  return (
    <button
      type="button"
      onClick={onClose}
      aria-label="Свернуть"
      data-testid="sheet-collapse"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
        width: '100%',
        padding: '8px 0 2px',
        margin: 0,
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        WebkitTapHighlightColor: 'transparent',
      }}
    >
      <span style={{ width: 40, height: 4, borderRadius: 2, background: pillColor, display: 'block' }} />
      <ChevronDown size={18} color="#9AA5B4" />
    </button>
  )
}
